import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0e7feea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "carousel carousel-product mb-4"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = { class: "ml-auto d-flex align-items-center shadow-none px-0 py-0 link-more" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "MÁS PRODUCTOS", -1))
const _hoisted_5 = { class: "row-products" }
const _hoisted_6 = { class: "px-1 py-3 w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_slide = _resolveComponent("slide")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.products.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.name !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h5", {
                class: _normalizeClass((_ctx.flash)? 'font-weight-bold d-block mb-0 deep-orange-text' : 'font-weight-bold d-block mb-0')
              }, _toDisplayString(_ctx.name), 3),
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPrev())),
                  class: "icon-arrow p-0 material-icons mr-1 border rounded"
                }, "keyboard_arrow_left", 512), [
                  [_vShow, _ctx.canPrev]
                ]),
                _hoisted_4,
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToNext())),
                  class: "icon-arrow p-0 material-icons ml-1 border rounded"
                }, "keyboard_arrow_right", 512), [
                  [_vShow, _ctx.canNext]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_carousel, {
            ref: "carousel",
            "items-to-show": 6,
            itemsToScroll: 6,
            mouseDrag: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, key) => {
                return (_openBlock(), _createBlock(_component_slide, { key: key }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ProductCard, { product: item }, null, 8, ["product"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 512)
        ])
      ]))
    : _createCommentVNode("", true)
}